import React, { memo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  format2NumberAtferComma,
  format2NumberAtferCommaMoney,
  format2NumberAtferCommaMoneyFormat,
  formatMoney,
  formatNumber,
  getDate,
} from "app/common/LocalFunction";
import { useFormikContext } from "formik";
import { optionLg, optionXs } from "./ReportPaymentOrganizationPieChart";
import { toast } from "react-toastify";

const ReportPaymentDepartmentPieChart = ({ data, isMobile }) => {
  const { values } = useFormikContext();

  // Common render function for custom label
  const renderCustomLabel = (chart, series, totalVisit) => {
    // Create or update custom label
    let customLabel = chart.options.chart.custom.label;

    if (!customLabel) {
      customLabel = chart.options.chart.custom.label = chart.renderer
        .label(``)
        .css({
          color: "#000",
          textAnchor: "middle",
          fontSize: `${series.center[2] / 12}px`,
        })
        .add();
    } else {
      customLabel.attr({
        text: ``,
      });
    }

    const x = series.center[0] + chart.plotLeft,
      y = series.center[1] + chart.plotTop - customLabel.getBBox().height / 2;

    customLabel.attr({
      x,
      y,
    });
  };

  function stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const c = (hash & 0x00ffffff).toString(16).toUpperCase();
    return "#" + "00000".substring(0, 6 - c.length) + c;
  }
  const options = {
    credits: {
      enabled: false, // Ẩn watermark Highcharts.com
    },
    chart: {
      type: "pie",
      height: "360px",
      //   marginRight: 120,
      // spacingRight: 150,
      custom: {},
      events: {
        render() {
          const chart = this;
          const series = chart.series[0];
          const totalVisit = data?.totalVisit;

          // Call the custom label rendering function
          renderCustomLabel(chart, series, totalVisit);

          document.querySelectorAll(".legend-copy").forEach((el) => {
            el.onclick = () => {
              const moneyText =
                el.querySelector(".number-hide")?.innerText || "";
              const departmentText =
                el.querySelector(".department-name")?.innerText || "";
              navigator.clipboard.writeText(+moneyText);
              toast.success(`Đã copy số liệu cơ sở ${departmentText}`);
            };
          });

          const el = document.querySelector(".chart-title-copy");
          el.onclick = () => {
            const moneyText = el.querySelector(".number-hide")?.innerText || "";

            navigator.clipboard.writeText(moneyText);
            toast.success(`Đã copy số liệu doanh thu cơ sở`);
          };
        },
      },
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    tooltip: {
      //   pointFormat:
      //     "{series.name}: <b>{point.percentage:.0f}%({point.y})</b>",
      formatter: function () {
        return `
      ${this.key}: 
      <b>${Highcharts.numberFormat(this.percentage, 0)}% 
      (${formatMoney(this.y)})</b>
    `;
      },
    },
    legend: {
      ...(!isMobile ? optionLg : optionXs),

      //   itemMarginTop: 5, // khoảng cách giữa các item
      //   itemMarginBottom: 50,
      useHTML: true,
      labelFormatter: function () {
        return `
        <div  class="legend-copy flex justify-between align-center" style="padding: 4px 0; border-bottom: 1px solid #eee; width: 280px;">
            <span class="department-name" style="font-weight: 600; color: #333;">${this?.name
          }</span>
            <span class="flex gap-1 align-center">
                <span class="money-number" style="float: right; color: #000;">${formatMoney(
            this.y || 0
          )}</span>
                <span style="font-size: 12px; color: #999;">${this.percentOfTotal || 0
          }%</span>
                <span class="number-hide">${this.y}</span>
            </span>
        </div>
      `;
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        borderRadius: 10,
        // center: ["50%", "50%"],
        dataLabels: {
          enabled: false,
          //   format: "{point.percentage:.0f}%({point.y})",
          //   style: {
          //     fontSize: "0.9em",
          //     color: "#000",
          //   },
          //   distance: 30,
        },
        showInLegend: true,
        innerSize: "25%",
        point: {
          events: {
            mouseOver: function () {
              this.graphic.attr({
                r: this.shapeArgs.r * 1.1,
              });
            },
            mouseOut: function () {
              this.graphic.attr({
                r: this.shapeArgs.r,
              });
            },
          },
        },
      },
    },
  };

  const options1 = {
    ...options,

    title: {
      useHTML: true,
      text: `
      <span class="chart-title-copy" 
            style="cursor:pointer;">
        Doanh thu cơ sở : ${formatMoney(data?.totalRevenue || 0)}
                <span class="number-hide">${data?.totalRevenue}</span>

      </span>
    `,
    },
    series: [
      {
        name: "",
        colorByPoint: true,
        // data: [
        //   { name: "Cơ sở Lê Hồng Phong", y: 10.92, color: "#5470c6" },
        //   { name: "Cơ sở Nguyễn Văn Trỗi", y: 10.57, color: "#ee6666" },
        //   { name: "Cơ sở Biên Hòa", y: 7.59, color: "#91cc75" },
        //   { name: "Cơ sở Bình Dương 1063", y: 6.94, color: "#fac858" },
        // ],
        data: data?.items?.map((el) => ({
          name: el?.department?.name,
          y: el?.totalRevenue,
          color: el?.department?.colorCode
            ? el?.department?.colorCode
            : stringToColor(el?.department?.name),
          percentOfTotal: el?.percentOfTotal?.toFixed(2),
        })),
      },
    ],
  };

  return (
    <div style={{ width: "100%", height: "360px" }}>
      <HighchartsReact highcharts={Highcharts} options={options1} />
    </div>
  );
};

export default memo(ReportPaymentDepartmentPieChart);
